//
// Category Link system (JS)
// 2019-04-19
//
// Space-Time Inc.
//

jQuery(function ($) {

	$('.item-category span').on('click', function (e) {
		if($(this).attr('data-url') != undefined){
			//伝播をストップ
			e.stopPropagation();
			e.preventDefault();
			//リンクを取得して飛ばす
			location.href = $(this).attr('data-url');
		};
	})

});
